import Button from ".";

const IconButton = ({
	icon = null,
	iconRight = false,
	size = "md",
	...props
}) => {
	return (
		<Button
			icon={icon}
			iconRight={iconRight}
			className={`${props.className || ""} icon`}
			size={size}
			{...props}
		/>
	);
};
export default IconButton;
